import name from './name'

const selectSliceData = state => state[name]
const selectUser = state => selectSliceData(state).user

export {
  selectUser
}
